module.exports = __webpack_public_path__ + "img/java.e5bc890e.png";